import React, {useState} from "react";
import { css } from "@emotion/core";
import ClockLoader from "react-spinners/ClockLoader";

export default function Spinner({show}) {
  
  let [loading, setLoading] = useState(show);
  let [color, setColor] = useState("#ffffff");

  const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
    z-index:200;
  `;

  return (
    <>
      {loading ? (
        <>
          <div className="opacity-50 fixed top-0 left-0 inset-0 z-5000 bg-indigo-500 w-full h-full"></div>  
          <div
            className="max-w-700-px spinner-center overflow-x-hidden overflow-y-auto fixed inset-0 z-5050 outline-none focus:outline-none justify-center items-center flex"            
          >                
            <ClockLoader color={color} loading={loading} css={override} size={150} />
          </div>
        </>
      ):null}
    </>
  );
}